var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{ref:"popup",staticClass:"popup",style:({ left: _vm.position.x + 'px', top: _vm.position.y + 'px' }),on:{"mouseenter":_vm.onPopupEnter,"mouseleave":_vm.onPopupLeave}},[_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }